import { render } from "./SidebarHeader.vue?vue&type=template&id=b1c229fc&scoped=true"
import script from "./SidebarHeader.vue?vue&type=script&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&lang=js"

import "./SidebarHeader.vue?vue&type=style&index=0&id=b1c229fc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c229fc"]])

export default __exports__